export default __webpack_public_path__ + "static/media/404-image.7780575a.png";